import { LucideIconData } from 'lucide-angular';

export const PoolCaC50: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['rect', { x: '8', y: '8', width: '8', height: '6', rx: '1' }],
  ['path', { d: 'M9 17 H15' }],
];
